import React from 'react';
import './ProjectsSlider.css'
import img1 from './../../../Assets/projects-slider/1.png'
import img2 from './../../../Assets/projects-slider/2.png'
import img3 from './../../../Assets/projects-slider/3.png'
import img4 from './../../../Assets/projects-slider/4.png'
import img5 from './../../../Assets/projects-slider/5.png'
import img6 from './../../../Assets/projects-slider/6.png'
import img7 from './../../../Assets/projects-slider/7.png'
import img8 from './../../../Assets/projects-slider/8.png'
import img9 from './../../../Assets/projects-slider/9.png'
import img10 from './../../../Assets/projects-slider/10.png'
import img11 from './../../../Assets/projects-slider/11.png'
import img12 from './../../../Assets/projects-slider/12.png'
import img13 from './../../../Assets/projects-slider/13.png'
import img14 from './../../../Assets/projects-slider/14.png'
import img15 from './../../../Assets/projects-slider/15.png'
import img16 from './../../../Assets/projects-slider/16.png'
import img17 from './../../../Assets/projects-slider/17.png'
import img18 from './../../../Assets/projects-slider/18.png'
import img19 from './../../../Assets/projects-slider/19.png'
import img20 from './../../../Assets/projects-slider/20.png'
import img21 from './../../../Assets/projects-slider/21.png'
import img22 from './../../../Assets/projects-slider/22.png'
import img23 from './../../../Assets/projects-slider/23.png'
import img24 from './../../../Assets/projects-slider/24.png'
import img25 from './../../../Assets/projects-slider/25.png'
import img26 from './../../../Assets/projects-slider/26.png'
import img27 from './../../../Assets/projects-slider/27.png'
import img28 from './../../../Assets/projects-slider/28.png'
import img29 from './../../../Assets/projects-slider/29.png'
import img30 from './../../../Assets/projects-slider/30.png'
import img31 from './../../../Assets/projects-slider/31.png'
import img32 from './../../../Assets/projects-slider/32.png'
import img33 from './../../../Assets/projects-slider/33.png'
import img34 from './../../../Assets/projects-slider/34.png'
import img35 from './../../../Assets/projects-slider/35.png'
import img36 from './../../../Assets/projects-slider/36.png'
import img37 from './../../../Assets/projects-slider/37.png'
import img38 from './../../../Assets/projects-slider/38.png'
import img39 from './../../../Assets/projects-slider/39.png'
import img40 from './../../../Assets/projects-slider/40.png'
import img41 from './../../../Assets/projects-slider/41.png'
import img42 from './../../../Assets/projects-slider/42.png'
import img43 from './../../../Assets/projects-slider/43.png'
import img44 from './../../../Assets/projects-slider/44.png'
import img45 from './../../../Assets/projects-slider/45.png'
import img46 from './../../../Assets/projects-slider/46.png'
import img47 from './../../../Assets/projects-slider/47.png'
import img48 from './../../../Assets/projects-slider/48.png'

const ProjectsSlider = () => {
    return (
        <div className='w-screen lg:w-full'>

            <div className="slider w-[363px] md:w-[730px] lg:w-full ">
                <div className="slide-track">

                    <div className="slide">
                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img1} alt="" />
                        </div>

                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img2} alt="" />
                        </div>

                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img3} alt="" />
                        </div>
                    </div>


                    <div className="slide mt-5 lg:mt-10">
                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img48} alt="" />
                        </div>

                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img40} alt="" />
                        </div>

                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img7} alt="" />
                        </div>
                    </div>


                    <div className="slide">
                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img13} alt="" />
                        </div>

                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img43} alt="" />
                        </div>

                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img44} alt="" />
                        </div>
                    </div>

                    <div className="slide mt-5 lg:mt-10">
                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img21} alt="" />
                        </div>

                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img22} alt="" />
                        </div>

                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img23} alt="" />
                        </div>
                    </div>


                    <div className="slide">
                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img25} alt="" />
                        </div>

                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img26} alt="" />
                        </div>

                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img27} alt="" />
                        </div>
                    </div>


                    <div className="slide mt-5 lg:mt-10">
                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img29} alt="" />
                        </div>

                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img30} alt="" />
                        </div>

                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img31} alt="" />
                        </div>
                    </div>


                    <div className="slide">
                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img9} alt="" />
                        </div>

                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img10} alt="" />
                        </div>

                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img11} alt="" />
                        </div>
                    </div>


                    <div className="slide mt-5 lg:mt-10">
                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img33} alt="" />
                        </div>

                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img34} alt="" />
                        </div>

                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img35} alt="" />
                        </div>
                    </div>

                    <div className="slide">
                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img17} alt="" />
                        </div>

                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img18} alt="" />
                        </div>

                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img19} alt="" />
                        </div>
                    </div>


                    <div className="slide mt-5 lg:mt-10">
                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img37} alt="" />
                        </div>

                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img38} alt="" />
                        </div>

                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img39} alt="" />
                        </div>
                    </div>

                    <div className="slide">
                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img41} alt="" />
                        </div>

                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img42} alt="" />
                        </div>

                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img14} alt="" />
                        </div>

                    </div>

                    <div className="slide mt-5 lg:mt-10">
                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img45} alt="" />
                        </div>

                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img46} alt="" />
                        </div>

                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img47} alt="" />
                        </div>
                    </div>

                    <div className="slide">
                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img4} alt="" />
                        </div>

                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img15} alt="" />
                        </div>

                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img16} alt="" />
                        </div>

                    </div>


                    <div className="slide mt-5 lg:mt-10">
                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img20} alt="" />
                        </div>

                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img28} alt="" />
                        </div>

                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img8} alt="" />
                        </div>
                    </div>


                    <div className="slide">
                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img36} alt="" />
                        </div>

                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img40} alt="" />
                        </div>

                        <div className='shadow-xl shadow-warning rounded-xl'>
                            <img src={img8} alt="" />
                        </div>


                    </div>

                </div>
            </div>
        </div>
    );
};

export default ProjectsSlider;